/**
 * File: hodViewController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Jeevanantham Nagarathinam
 * -----
 * Last Modified: 2018-12-05
 * Modified By: Jeevanantham Nagarathinam
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class HodViewController {
    // @ngInject
    constructor($state, $rootScope, $scope, $mdDialog, $stateParams, localStorageService, authService, profileCons) {

        let self = this;
        let selectedUserId = $stateParams.person_id
        let addedSessionsID = [];
        $scope.showSessionName = [];
        $scope.showCurriculumName = [];
        $scope.userMgt = {}
        $scope.firstLoad = true //flag to check the page is loaded first or not

        let module_privileges = localStorageService.get("feature_privileges")


        $scope.userAccess = {}
        let features = module_privileges;
        let userAccessJson = _.filter(features, function(feature) {
            return feature.module_state == "userEndorsement";
        });
        if (userAccessJson) {
            _.each(userAccessJson, function(feature) {
                let user_access = {};
                _.each(feature.privilege, function(privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.userAccess = user_access;
            })
        } else {
            $state.go("dashboard")
        }


        self.myStudents = [];
        if (!selectedUserId) {
            $state.go('profileSetting');
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Get endorsed department
         **/
        let hodEndorsedDept = () => {
            $scope.roleHOD = true;
            authService.callAPI(profileCons.API_HOD_ENDORSE_DETAILS + localStorageService.get('school_id') + "/" + selectedUserId, "GET", {}, (response) => {
                //console.log(response)
                if (response.result && response.result.data && response.result.data.departments) {
                    $scope.hodPersonArr = response.result.data.departments
                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Load session list
         **/
        let sessionDet = () => {
            authService.callAPI(profileCons.API_GET_SESSION + localStorageService.get('school_id'), "GET", {}, (response) => {
                //console.log(response)
                if (response.result && response.result.data && response.result.data.details) {
                    $scope.sessionLst = response.result.data.details
                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Load curriculum list
         **/
        let curriculumDet = (session_id) => {
            authService.callAPI(profileCons.API_GET_CURRICULUM + localStorageService.get('school_id') + "/" + session_id, "GET", {}, (response) => {
                //console.log(response)
                if (response.result && response.result.data && response.result.data.details) {
                    $scope.curriculumLst = response.result.data.details
                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Load subject list
         **/
        let departmentDet = (curriculum_id) => {
            authService.callAPI(profileCons.API_GET_SUBJECTS + localStorageService.get('school_id') + "/" + $scope.userMgt.session_id + "/" + curriculum_id+ "/"+selectedUserId, "GET", {}, (response) => {
                //console.log(response)
                if (response.result && response.result.data && response.result.data.details) {
                    $scope.subjectLst = response.result.data.details
                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: update department
         **/
        let updateDepartment = (academic_obj, user_id) => {

            let obj = {
                curriculum_id: academic_obj.curriculum_id,
                session_id: academic_obj.session_id,
                school_id: localStorageService.get('school_id'),
                subjects: academic_obj.subjects,
                user_id: user_id
            }

            authService.callAPI(profileCons.API_UPDATE_DEPARTMENT, "POST", obj, (response) => {
                if (response.result && response.result.status && response.result.status.code == 200) {
                    toastr.success("Updated successfully!")
                }

                $scope.firstLoad = false
                $scope.userMgt = {};
                hodEndorsedDept()
                $scope.showAddBtn = false;
                $scope.curriculumLst = [];
                $scope.subjectLst = [];
            })
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Remove department
         **/
        let removeDepartment = (user_id, academic_obj) => {
            let obj = {
                curriculum_id: academic_obj.curriculum_id,
                session_id: academic_obj.session_id,
                subject_id: academic_obj.department_id,
                user_id: user_id
            }
            authService.callAPI(profileCons.API_DELETE_DEPARTMENT, "POST", obj, (response) => {
                if (response.result && response.result.status && response.result.status.code == 200) {
                    hodEndorsedDept()
                    toastr.success("Deleted successfully!")
                }
            })
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: Initialization
         **/
        this.$onInit = () => {
            hodEndorsedDept()
            sessionDet()
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: call fn to load curriculum list
         **/
        $scope.getCuriculumLst = (session_id) => {
            curriculumDet(session_id)
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: call fn to load subject list
         **/
        $scope.getSubjectsLst = (curriculum_id) => {
            departmentDet(curriculum_id)
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: call fn to update department
         **/
        $scope.updateDepartment = () => {
            $scope.userMgt.school_id = localStorageService.get('school_id')
            if ($scope.userMgt.curriculum_id !== undefined && $scope.userMgt.session_id !== undefined) {
                if ($scope.userMgt.subjects && $scope.userMgt.subjects.length > 0) {
                    updateDepartment($scope.userMgt, selectedUserId)
                } else {
                    toastr.error("Please select atleast one subject")
                }
            } else {
                if ($scope.userMgt.curriculum_id === undefined && $scope.userMgt.session_id === undefined) {
                    toastr.error("Please select all necessary fields")
                } else {
                    if ($scope.userMgt.curriculum_id === undefined) {
                        toastr.error("Please select curriculum")
                    }
                    if ($scope.userMgt.session_id === undefined) {
                        toastr.error("Please select session")
                    }
                }
            }
        }


        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: call fn to set visibility of add btn
         **/
        $scope.getData = () => {
            $scope.showAddBtn = true;
        }

        /** 
         * @Author: Jeevanantham N
         * @Date: 2018-12-05
         * @Desc: call fn to conform delete department
         **/
        $scope.deleteSubject = (department) => {
            let selectedUserId = $stateParams.person_id
            var confirm = $mdDialog.confirm()
                .title('')
                .textContent('Are you sure to remove ?')
                .targetEvent(event)
                .ok('Yes')
                .cancel('No');
            $mdDialog.show(confirm).then(function() {
                removeDepartment(selectedUserId, department)
            }, function() {});
        }
    }
}


export default HodViewController;


// WEBPACK FOOTER //
// ./src/app/profileSetting/controllers/hodViewController.js